import { useTranslation } from 'react-i18next';
import ChatBubble from '../../../components/Chat/Chat';
import AskMascot from '../../../assets/kitoBuddy/Kito-Asking-What-to-do 3.png';
import ADULTSIGNSANDSYMPTOMSIMAGES from '../../../assets/designSystem/icons/StaticPages/Symptoms';

export default function WhatToDo({ title, options = [] }) {
  const { t } = useTranslation();
  return (
    <div>
      <ChatBubble img={AskMascot} text={t(title)} />
      <div className="what__content">
        {options.map((option) => (
          <div key={option.label} className="whattodo__content">
            <div className="symptoms__cont">
              <img src={ADULTSIGNSANDSYMPTOMSIMAGES[option.icon]} alt="symptoms" />
            </div>
            <p>{t(option.label)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
